var map = {
	"./Arts & Crafts, School & Office.png": "162f",
	"./Automotive.png": "a836",
	"./Baby.png": "03664",
	"./Beauty & Personal Care.png": "779c",
	"./Computers.png": "1729",
	"./DIY, Tools & Lighting.png": "25e0",
	"./Electronics, Smart Home & Appliances.png": "302e",
	"./Fashion, Textiles & Fabrics.png": "0eb9",
	"./Garden & Outdoor.png": "5ae7",
	"./Health & Medical.png": "7932",
	"./Home, Kitchen & Office.png": "b746",
	"./Industrial & Scientific.png": "f58e",
	"./Others.png": "2bcb",
	"./PPE.png": "0772",
	"./Packaging.png": "b0b7",
	"./Pet Supplies.png": "af2b",
	"./Sports & Fitness.png": "0d61",
	"./Toys & Games.png": "0c7f",
	"./Travel, Bags & Luggage.png": "dfa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9df";